const incomeSources = [
  {
    value: 'Full-time',
    text:  'Funcionário com Carteira Assinada (CLT)',
  },
  {
    value: 'Government',
    text:  'Funcionário Público ou Militar',
  },
  {
    value: 'Self-employed',
    text:  'Profissional Autônomo',
  },
  {
    value: 'Informal',
    text:  'Informal ou Não Registrado',
  },
  {
    value: 'Retired',
    text:  'Aposentado ou Pensionista',
  },
  {
    value: 'Other',
    text:  'Outros',
  },
];
export default incomeSources;
